import InvoicePaymentsHtml from './templates/invoice-payments.html';

export function InvoicePaymentsDirective () {
  return {
    controller: 'InvoicePaymentsCtrl',
    restrict: 'E',
    templateUrl: InvoicePaymentsHtml,
    scope: {
      invoice: '=',
      payments: '='
    }
  }
}